export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/70 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 md:gap-10 pb-10 md:pb-14 border-b border-foreground-700/50">
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-heading font-extrabold text-background-50 tracking-tight">
                棒棒<span className="text-primary-400">TV</span>
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-5 max-w-sm">
              棒棒TV —— 免费在线观看高清视频平台。提供不卡顿、免缓冲的流畅播放体验，
              电视剧全集、电影大全、最新剧集一网打尽，让每个人都能轻松看好片。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-700/50 text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-700/50 text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-700/50 text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '精彩推荐', href: '#media' },
                { label: '观众热评', href: '#comments' },
                { label: '热播榜单', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-xs text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {[
                { label: '电视剧大全', href: '#index' },
                { label: '电影片库', href: '#index' },
                { label: '综艺娱乐', href: '#index' },
                { label: '动漫番剧', href: '#index' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-xs text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-400 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-xs text-foreground-400 text-center sm:text-left">
            &copy; 2026 棒棒TV · 免费在线观看高清视频 · 不卡顿免缓冲流畅播放
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}